import React from 'react';
import { SingleCommonType } from '../../types';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { matchedTypePlaceholder } from '../../constants/placeholder';
import { matchedTypeOptions } from '../../constants/matchedType';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import './index.scss';

export default function MatchedTypeSelect(props: SingleCommonType) {
  return (
    <div className="matched-type-select-wrapper">
      <CommonSingleSelect
        {...props}
        returnKey="matched_type"
        boxClassName="matched-type-select"
        singlePlaceholder={matchedTypePlaceholder}
        options={matchedTypeOptions}
        initValue="-"
        pointKey={FilterButtonPoint.matchedType}
        dealwithReturnValue={(value: string) => {
          return value === '-' ? '' : value;
        }}
      />
    </div>
  );
}
